export default {
  'primary-lightest' : '#ECF7FF',
  'primary-lighter' : '#B2E1FF',
  'primary-light' : '#79CAFF',
  'primary' : '#3FB3FF',
  'primary-dark' : '#39A1E6',
  'primary-darker' : '#266B99',
  'primary-darkest' : '#13364D',

  'secondary-lightest' : '#FFFAE9',
  'secondary-lighter' : '#FDEBA6',
  'secondary-light' : '#FCDD63',
  'secondary' : '#FBCE20',
  'secondary-dark' : '#E2B91D',
  'secondary-darker' : '#977C13',
  'secondary-darkest' : '#4B3E0A',

  'success-lightest' : '#EAF6EC',
  'success-lighter' : '#A9DCB5',
  'success-light' : '#69C17D',
  'success' : '#28A745',
  'success-dark' : '#24963E',
  'success-darker' : '#186429',
  'success-darkest' : '#0C3215',

  'danger-lightest' : '#FCEBEC',
  'danger-lighter' : '#F1AEB5',
  'danger-light' : '#E7727D',
  'danger' : '#DC3545',
  'danger-dark' : '#C6303E',
  'danger-darker' : '#842029',
  'danger-darkest' : '#421015',

  'warning-lightest' : '#FFF9E6',
  'warning-lighter' : '#FFE69C',
  'warning-light' : '#FFD451',
  'warning' : '#FFC107',
  'warning-dark' : '#E6AE06',
  'warning-darker' : '#997404',
  'warning-darkest' : '#4D3A02',

  'info-lightest' : '#E8F6F8',
  'info-lighter' : '#A2DAE3',
  'info-light' : '#5DBECD',
  'info' : '#17A2B8',
  'info-dark' : '#1592A6',
  'info-darker' : '#0E616E',
  'info-darkest' : '#073137',

  'light-lightest' : '#FEFEFF',
  'light-lighter' : '#FCFDFD',
  'light-light' : '#FAFBFC',
  'light' : '#F8F9FA',
  'light-dark' : '#DFE0E1',
  'light-darker' : '#959596',
  'light-darkest' : '#4A4B4B',

  'dark-lightest' : '#EBEBEC',
  'dark-lighter' : '#AEB0B3',
  'dark-light' : '#717579',
  'dark' : '#343A40',
  'dark-dark' : '#2F343A',
  'dark-darker' : '#1F2326',
  'dark-darkest' : '#101113',

  'grey-lightest' : '#F8F9FA',
  'grey-lighter' : '#E3E7EB',
  'grey-light' : '#CDD4DB',
  'grey' : '#B8C2CC',
  'grey-dark' : '#A6AFB8',
  'grey-darker' : '#6E747A',
  'grey-darkest' : '#373A3D',

  'sidebar-bg': '#FFFFFF',
  'sidebar-text': '#000000',
  'menu-text': '#000000',
  'menu-text-hover': '#3FB3FF',

  'footer-bg': '#F8F9FA', // Same as 'light'.
  'footer-text-normal': '#4A4B4B', // Same as 'light-darkest'.
  'footer-text-lighter': '#AEB0B3', // Same as 'dark-lighter'.
}
